import { makeStyles } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import Configuration from './configuration';

export const FORM_FIELDS_COLOR = '#DEDEDE';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: `url(${Configuration.backgroundImage})`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    color: FORM_FIELDS_COLOR,
  },
  link: {
    justifyContent: 'center',
    display: 'flex',
    margin: 25,
    color: 'inherit !important',
  },
  cardView: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 3rem',
    minHeight: '60vh',
    borderRadius: '24px',
    border: '3px solid #2E3546',
    background: 'rgba(0, 0, 0, 0.2)',
    color: 'inherit',
  },
  root1: {
    background:
      'linear-gradient(to right, ' +
      theme.palette.primary.dark +
      ' 0%, ' +
      darken(theme.palette.primary.dark, 0.5) +
      ' 100%)',
    color: theme.palette.primary.contrastText,
    width: '40%',
  },
  languageButton: {
    position: 'absolute',
    right: 20,
    top: 8,
  },
}));

export default useStyles;
